<template>
  <div>
    <div class="panel panel--minimal-pad">
      <div class="panel__header">
        <div class="panel__header__left panel__header-width-m">
          <!-- <div class="search-form width-100">
            <span class="search hidden--xs">
              <span class="search__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <path fill="#919EAB" fill-rule="evenodd" d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>
                  </svg>
              </span>
              <span class="search__input">
                  <input type="text" class="form__input" placeholder="Search beneficiaries">
              </span>
            </span>
          </div>-->
          <div class="panel__header__left">Your Saved Beneficiaries</div>
        </div>
        <div class="panel__header__right">
          <!-- <div class="filter__options">
            <button class="btn btn--default btn--flex">
            <span class="btn__icon">
              <svg class="" enable-background="new 0 0 971.986 971.986" version="1.1" viewBox="0 0 971.986 971.986" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#576ae6" d="m370.22 459.3c10.2 11.1 15.8 25.6 15.8 40.6v442c0 26.601 32.1 40.101 51.1 21.4l123.3-141.3c16.5-19.8 25.6-29.601 25.6-49.2v-272.8c0-15 5.7-29.5 15.8-40.601l353.8-383.9c26.5-28.8 6.101-75.5-33.1-75.5h-873c-39.2 0-59.7 46.6-33.1 75.5l353.8 383.8z" />
              </svg>
            </span>
              <span class="btn__text">Add filter</span>
            </button>
          </div>-->
          <div class="contact-trigger">
            <a
              class="btn btn--default btn--flex"
              title="create wallet"
              data-toggle="modal"
              data-target="#createBeneficiaryModal"
            >
              <span class="btn__icon">+</span> Add Beneficiaries
            </a>
          </div>
        </div>
      </div>
      <div class="panel__content panel__content--grey outer-container">
        <div class="table__section table__section--head">
          Showing
          <span>all beneficiaries</span>
        </div>
        <!--beneficiaries list table-->
        <!--transfer loading-->
        <div class="loaderContainer" v-if="isLoading">
          <img src="/static/wave.gif" alt width="32" height="32">
        </div>

        <transition name="slide-fade">
          <div class="table" v-if="!isLoading">
            <!-- Table body -->
            <div
              class="table__section table__section--body"
              v-for="beneficiary in beneficiariesList.data"
            >
              <!-- table row -->
              <div class="table__row">
                <!-- table data -->
                <div class="table__data">
                  <div class="table__data--bold">{{beneficiary.alias}}</div>
                </div>
                <!-- table data -->
                <div class="table__data" style="width: 12%;">
                  <div
                    class="table__data--default"
                    v-if="beneficiary.phonenumber === null || beneficiary.phonenumber === ''"
                  >No phone</div>
                  <div
                    class="table__data--default"
                    v-else-if="beneficiary.phonenumber"
                  >{{beneficiary.phonenumber}}</div>
                  <div
                    class="table__data--sub"
                    v-if="beneficiary.email === null || beneficiary.email === ''"
                  >No email</div>
                  <div class="table__data--sub" v-else>{{beneficiary.email}}</div>
                </div>
                <!-- table data -->
                <div class="table__data" style="width: 12%;">
                  <div class="table__data--default">{{beneficiary.createdAt}}</div>
                  <div class="table__data--sub">Date created</div>
                </div>

                <!-- table data -->
                <div class="table__data" style>
                  <div class="table__data--default">{{beneficiary.accountName}}</div>
                  <div
                    class="table__data--sub"
                  >{{beneficiary.tag}} - {{beneficiary.accountNumber}} - {{beneficiary.countryTag}}</div>
                </div>

                <!-- table data -->
                <div class="table__data">
                  <a
                    v-if="enableActions"
                    class="btn btn--default btn--compact"
                    title="delete beneficiary"
                    data-toggle="modal"
                    data-target="#createSureModal"
                    @click="getId(beneficiary.id)"
                  >Delete</a>
                  <!--<button class="btn btn&#45;&#45;default btn&#45;&#45;compact delete_button" @click="DeleteBe(beneficiary.id)">Delete</button>-->
                </div>
              </div>
              <div class="table__row spacer"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!--pagination-->
    <transition name="slide-fade">
      <pagination
        :paginationProp="paginationProp"
        v-if="!paginationProp.paginationEmpty"
        :key="paginationProp.pagination.total"
      ></pagination>
    </transition>

    <div
      class="modal fade"
      id="createSureModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createSureModal"
    >
      <div class="modal__dialog modal__dialog--sm">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Remove Beneficiary
            </div>
          </div>

          <div
            class="modal__body"
            style="padding: 40px 10px 30px 10px; display:flex; flex-direction: row; justify-content: center;"
          >
            <div
              class="form disburse-form"
              style="display:flex; flex-direction: row; justify-content: center;"
            >
              <div class style="margin-right:30px" v-if="enableActions">
                <button
                  class="btn btn--default"
                  data-dismis="modal"
                  aria-label="Close"
                  data-toggle="modal"
                  data-target="#createSureModal"
                >Cancel</button>
              </div>
              <div class v-if="enableActions">
                <button
                  class="btn btn--primary"
                  id="delete_button"
                  style="margin-bottom:15px;"
                  @click="DeleteBe(beneficiaryId)"
                  type="submit"
                >Delete</button>
              </div>
            </div>
          </div>
              <div id="snackbar"></div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="createBeneficiaryModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="createBeneficiaryModal"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--xlg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
          <div class="modal__header">
            <div class="modal__title">
              <span class="time-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="512px"
                  height="512px"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                  class="icon--sm"
                >
                  <g>
                    <g>
                      <g>
                        <path
                          d="M587.572,186.881c-32.266-75.225-87.096-129.934-162.949-162.285C386.711,8.427,346.992,0.168,305.497,0.168    c-41.488,0-80.914,8.181-118.784,24.428C111.488,56.861,56.415,111.535,24.092,186.881C7.895,224.629,0,264.176,0,305.664    c0,41.496,7.895,81.371,24.092,119.127c32.323,75.346,87.403,130.348,162.621,162.621c37.877,16.247,77.295,24.42,118.784,24.42    c41.489,0,81.214-8.259,119.12-24.42c75.853-32.352,130.683-87.403,162.956-162.621C603.819,386.914,612,347.16,612,305.664    C612,264.176,603.826,224.757,587.572,186.881z M538.724,440.853c-24.021,41.195-56.929,73.876-98.375,98.039    c-41.195,24.021-86.332,36.135-134.845,36.135c-36.47,0-71.27-7.024-104.4-21.415c-33.129-14.384-61.733-33.294-85.661-57.215    c-23.928-23.928-42.973-52.811-57.214-85.997c-14.199-33.065-21.08-68.258-21.08-104.735c0-48.52,11.921-93.428,35.807-134.509    c23.971-41.231,56.886-73.947,98.039-98.04c41.146-24.092,85.99-36.142,134.502-36.142c48.52,0,93.649,12.121,134.845,36.142    c41.446,24.164,74.283,56.879,98.375,98.039c24.092,41.153,36.135,85.99,36.135,134.509    C574.852,354.185,562.888,399.399,538.724,440.853z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                        <path
                          d="M324.906,302.988V129.659c0-10.372-9.037-18.738-19.41-18.738c-9.701,0-18.403,8.366-18.403,18.738v176.005    c0,0.336,0.671,1.678,0.671,2.678c-0.671,6.024,1.007,11.043,5.019,15.062l100.053,100.046c6.695,6.695,19.073,6.695,25.763,0    c7.694-7.695,7.188-18.86,0-26.099L324.906,302.988z"
                          data-original="#000000"
                          class="active-path"
                          data-old_color="#576ae6"
                          fill="#576ae6"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </span>
              Add a New Beneficiary
            </div>
            <!-- Modal close button -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="triggerRefresh()"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad">
            <div class>
              <form
                action
                class="form disburse-form"
                @submit.prevent="handleCreateBeneficiaries()"
                v-if="addBeneficiaryNotFinished"
              >
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    Beneficiary
                    <span>Name</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="text"
                      name="name"
                      placeholder="ex. Supplier, Food Vendor, Utilities, Insurance"
                      v-model="createObject.name"
                      id="walletName"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                    >
                  </div>
                </div>
                <div class="form__item">
                  <label for="bank" class="form__label--span form--left">
                    Select
                    <span>Bank</span>
                  </label>
                  <div class="select form--right">
                    <select
                      name="bankCode"
                      id="bank"
                      class="select__input"
                      v-model="createObject.bankCode"
                      @change="selectedBank(createObject.bankCode)"
                    >
                      <option disabled value>Select Bank</option>
                      <option
                        v-for="bank in banksList"
                        v-bind:value="[bank.country, bank.value]"
                      >{{ bank.country }} - {{bank.name}}</option>
                    </select>
                    <div class="select__icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="10"
                        viewBox="0 0 6 10"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form__item" v-if="branchRequired">
                  <label for="bank" class="form__label--span form--left">
                    Select
                    <span>Branch</span>
                  </label>
                  <div class="select form--right">
                    <select
                      name="branch"
                      id="branch"
                      class="select__input"
                      v-model="createObject.branchCode"
                    >
                      <option value disabled>Select Branch</option>
                      <option
                        v-for="(branch, code) in branchListObj"
                        v-bind:value="code"
                        v-bind:key="code"
                      >{{branch}}</option>
                    </select>
                    <div class="select__icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="6"
                        height="10"
                        viewBox="0 0 6 10"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    Account
                    <span>Number</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="text"
                      name="accountNumber"
                      placeholder
                      v-model="createObject.accountNumber"
                      id="walletName"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                    >
                  </div>
                  <span style="position: absolute; right: 30px">
                    <small>{{ accountNameInfo }}</small>
                  </span>
                </div>
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    <span>Email</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="text"
                      name="email"
                      placeholder
                      v-model="createObject.email"
                      id="walletName"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                      @click="utilityMethods().resolveAccountName()"
                    >
                  </div>
                </div>
                <div class="form__item">
                  <label for="beneficiarySource" class="form__label--span form--left">
                    <span>Phone Number</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="text"
                      name="phone_number"
                      placeholder
                      v-model="createObject.phone_number"
                      id="walletName"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                    >
                  </div>
                </div>

                <div class="form__item">
                  <button
                    id="fundWallet"
                    type="submit"
                    class="btn btn--primary btn--block beneficiary_submit"
                  >Create Beneficiary</button>
                </div>
              </form>

              <div class="disburse__result text-center" v-if="addBeneficiaryDone">
                <div v-if="addBeneficiarySuccessful">
                  <!--success icon-->
                  <div class="result-img">
                    <svg
                      class="icon icon--custom-big"
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline
                        points="38 15 22 33 12 25"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    class="disburse__result__success success-text"
                  >Beneficiary Created successfully!</p>
                  <button
                    class="btn btn--primary"
                    @click="triggerPageLoad2()"
                  >Add another beneficiary</button>
                  <button
                    class="btn btn--default"
                    @click="triggerRefresh()"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createBeneficiaryModal"
                  >End</button>
                </div>

                <div v-if="addBeneficiaryFailed">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                      <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                    </svg>
                  </div>
                  <p
                    v-for="error in beneficiaryErrors"
                    class="disburse__result__error error-text"
                  >{{error}}</p>
                  <button class="btn btn--primary" @click="triggerPageLoad()">Retry</button>
                  <button
                    class="btn btn--default"
                    @click="triggerRefresh()"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#createBeneficiaryModal"
                  >See all beneficiaries</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationView from "@/components/partials/PaginationView";
import { getAllBanks } from "../../utils/helpers/utilitiesService";
import { getBankBranch } from "../../utils/helpers/utilitiesService";
import {
  getBeneficiaries,
  createBeneficiaries,
  deleteBeneficiary
} from "../../utils/wallet-transactions/beneficiariesService";
import ModalTemplate from "@/components/partials/ModalTemplate.vue";
import { resolveAccountName } from "../../utils/helpers/utilitiesService";

export default {
  created() {
    this.handleBeneficiariesList();
    this.getBanklist.handleBanksFetch();
  },

  data() {
    return {
      isLoading: true,
      beneficiariesList: [],
      beneficiaryData: {},
      bankSelected: "",
      branchRequired: false,
      paginationProp: {
        pagination: {},
        paginationEmpty: true,
        pathName: ""
      },
      addBeneficiaryDone: false,
      addBeneficiarySuccessful: false,
      addBeneficiaryFailed: false,
      addBeneficiaryNotFinished: true,
      beneficiaryErrors: [],
      banksList: [],
      accountNameInfo: "",
      createObject: {
        bankCode: "",
        accountNumber: "",
        name: "",
        phone_number: "",
        email: "",
        branchCode: "",
        country: "",
        currency: "",
      },
      beneficiaryId: "",
      banksListObj: {},
    };
  },
  components: {
    pagination: PaginationView,
    "modal-template": ModalTemplate
  },
  computed: {
    enableActions: {
      get() {
        return this.$store.state.enableActions;
      },
    },
    getBanklist() {
      let self = this;
      return {
        handleBanksFetch() {
          //this function calls the getWallets service.
          getAllBanks()
            .then(response => {
              if (response.status === 200) {
                //reset list first
                self.banksList.length = 0;
                response.data.data.forEach(bank => {
                  self.banksList.push({
                    name: bank.name,
                    country: bank.country,
                    value: bank.code,
                    shortCode: bank.shortCode
                  });
                });
              }
              self.banksList.forEach((res) => {
                self.banksListObj[`${res.country}-${res.value}`] = { name: res.name, country: res.country, currency: res.shortCode };
              })
            })

            //catch error from the getWallets API and do something about the errors
            .catch(error => {
              self.$Progress.fail();
            });
        }
      };
    }
  },
  methods: {
    selectedBank(bankcode) {
      const b = this.banksListObj[`${bankcode[0]}-${bankcode[1]}`];
      const self = this;
      self.branchRequired = false;
      getBankBranch(bankcode[1], b.country).then(resp => {
        if (
          resp.status === 200 &&
          resp.data &&
          resp.data.data &&
          Object.values(resp.data.data).length
        ) {
          self.branchListObj = resp.data.data;
          self.branchRequired = true;
        }
      });
      self.createObject.country = b.country;
      self.createObject.currency = b.currency;
    },
    handleBeneficiariesList() {
      getBeneficiaries(this.$route.query.per_page, this.$route.query.page)
        .then(response => {
          this.isLoading = false;
          if (response.status === 200 && response.data.data.length) {
            this.beneficiariesList = response.data;
            let i = 0;
            this.beneficiariesList.data.forEach(data => {
              this.beneficiariesList.data[i]["createdAt"] = data[
                "createdAt"
              ].slice(0, 10);
              i++;
            });
            if (response.data.meta.pagination.total > 0) {
              this.paginationProp.pagination = response.data.meta.pagination;
              this.paginationProp.paginationEmpty = false;
              this.paginationProp.pathName = this.$route.name;
            } else {
              this.paginationProp.paginationEmpty = true;
            }
          }
        })

        .catch(error => {
          console.log(error);
        });
    },
    handleCreateBeneficiaries() {
      let submitBtn = document.getElementsByClassName("beneficiary_submit");
      submitBtn.disabled = true;
      submitBtn.innerHTML = "Processing...";
      let app = this;
      this.$Progress.start();
      createBeneficiaries(this.createObject)
        .then(response => {
          if (response.status === 200) {
            this.addBeneficiaryNotFinished = false;
            this.addBeneficiaryDone = true;
            // if (response.data.status === "success") {
            this.addBeneficiarySuccessful = true;
            this.addBeneficiaryFailed = false;
            // }
            this.$Progress.finish();
          } else {
            this.addBeneficiaryNotFinished = false;
            this.addBeneficiaryDone = true;
            this.addBeneficiarySuccessful = false;
            this.addBeneficiaryFailed = true;
          }
        })
        .catch(err => {
          this.$Progress.fail();
          console.log(err.response);
          this.beneficiaryErrors.push(err.response.data.message || err.response.data.error.message);
          this.addBeneficiaryDone = true;
          this.addBeneficiaryNotFinished = false;
          this.addBeneficiaryFailed = true;
          this.addBeneficiarySuccessful = false;
        });
    },

    utilityMethods() {
      let self = this;

      return {
        resolveAccountName() {
          if (self.createObject.accountNumber.length >= 9) {
            self.accountNameInfo = "Checking ...";
            let app = this;
            let accountObject = {
              accountNumber: self.createObject.accountNumber,
              accountBankCode: self.createObject.bankCode[1]
            };
            resolveAccountName(accountObject)
              .then(response => {
                if (response.status === 200) {
                  self.accountNameInfo = response.data.accountName;
                } else {
                  self.accountNameInfo = null;
                }
              })
              .catch(error => {
                self.accountNameInfo = null;
              });
          }
        }
      };
    },

    //   filteredBanks() {
    //   let filterString = this.payoutObj.wallet.currency.charAt(0),
    //     banksListArray = this.banksList;
    //   if (
    //     filterString == "" ||
    //     filterString === undefined ||
    //     filterString === null
    //   ) {
    //     return banksListArray;
    //   } else {
    //     filterString = filterString.trim().toLowerCase();
    //     banksListArray = banksListArray.filter(function(bank) {
    //       if (bank.country.toLowerCase().indexOf(filterString) !== -1) {
    //         return banksListArray;
    //       } else {
    //         return banksListArray;
    //       }
    //     });
    //   }
    //   return banksListArray;
    // },

    triggerRefresh() {
      self.beneficiaryErrors = [];
      self.showModal = false;
      self.addBeneficiaryNotFinished = true;
      self.addBeneficiaryFailed = false;
      self.addBeneficiaryDone = false;
      self.addBeneficiarySuccessful = false;
      self.createObject.phone_number = "";
      self.createObject.name = "";
      self.createObject.bankCode = "";
      self.createObject.accountNumber = "";
      self.createObject.email = "";
      self.createObject.branchCode = "";
      self.branchRequired = false;
      self.handleBeneficiariesList();
    },
    triggerPageLoad() {
      // self.$router.replace(this.$route.name);
      self.beneficiaryErrors = [];
      self.showModal = false;
      self.addBeneficiaryNotFinished = true;
      self.addBeneficiaryDone = false;
      self.addBeneficiaryFailed = false;
      self.addBeneficiarySuccessful = false;
    },
    triggerPageLoad2() {
      // self.$router.replace(this.$route.name);
      self.beneficiaryErrors = [];
      self.showModal = false;
      self.addBeneficiaryNotFinished = true;
      self.addBeneficiaryFailed = false;
      self.addBeneficiaryDone = false;
      self.addBeneficiarySuccessful = false;
      self.createObject.phone_number = "";
      self.createObject.name = "";
      self.createObject.bankCode = "";
      self.createObject.accountNumber = "";
      self.createObject.email = "";
      self.branchRequired = false;
      self.createObject.branchCode = "";
      // document.getElementById('walletName').value = "";
      // document.getElementById('bank').selectedIndex = 0;
    },
    DeleteBe(id) {
      let self = this;
      self.$Progress.start();
      let submitBtn = document.getElementById("delete_button");
      submitBtn.disabled = true;
      deleteBeneficiary(id)
        .then(response => {
          self.$Progress.finish();
          this.showSnackbar('Beneficiary Deleted Successfully');
          self.handleBeneficiariesList();
          setTimeout(() => {
            $('#createSureModal').modal('hide');
            submitBtn.disabled = false;
          }, 2000);
        })
        .catch(error => {
          this.showSnackbar(error.response && error.response.data ? error.response.data.message : 'An error occured');
          self.$Progress.fail();
          submitBtn.disabled = false;
          console.log(error.response);
        });
      $("#modalWindow").modal("hide");
      // this.$emit('close');
    },
    getId(id) {
      this.beneficiaryId = id;
    },
    showSnackbar(text) {
      let snackbar = document.getElementById("snackbar");
      snackbar.innerHTML = text;
      snackbar.className = "show";
      text.includes('Successfully') ? snackbar.style.color = 'blue' : snackbar.style.color = 'red';
      setTimeout(function() {
        snackbar.className = snackbar.className.replace("show", "");
      }, 4000);
    }
  }
};
</script>
<style scoped>
#snackbar {
  visibility: hidden;
  /*poisition: fixed;*/
  top: 0px;
  background-color: white;
  /* color: red; */
  padding: 5px;
  text-align: center;
}

#snackbar.show {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/beneficiaries/BeneficiariesList.vue